// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--aHM3t","error":"error--diNIh","linkContainer":"linkContainer--ZwVlb","link":"link--jNtda"};